import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'constants/query-keys';
import { getSearchSuggestions } from 'services/SearchService';

import type { ISearchSuggestions, QueryClient, ReactQueryOptions } from 'types';

export function useSearchSuggestions(query: string, options: ReactQueryOptions<ISearchSuggestions> = {}) {
  return useQuery({
    queryKey: getKey(query),
    queryFn: () => getSearchSuggestions(query),
    retry: 1,
    ...options
  });
}

function getKey(query: string) {
  return [
    QUERY_KEYS.SEARCH_SUGGESTIONS,
    query
  ];
}

export async function prefetchSearchSuggestions(query: string, queryClient: QueryClient) {
  const key = getKey(query);
  await queryClient.prefetchQuery({
    queryKey: key,
    queryFn: () => getSearchSuggestions(query)
  });
}
